import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Dashboard Views
import Index from './Dashboard/Index';
import Client from './Dashboard/Client';
import ClientDetails from './Dashboard/ClientDetails';
import Deposits from './Dashboard/Deposit';
import DepositWallet from './Dashboard/DepositWallet';
import ClientWithdraw from './Dashboard/ClientWithdraw';
import WithdrawRequest from './Dashboard/WithdrawRequest';
import Withdraw from './Dashboard/Withdraw';
import Trades from './Dashboard/Trades';
import Rank from './Dashboard/Rank';
import Business from './Dashboard/Business';
import MasterWallet from './Dashboard/MasterWallet';
import Cofund from './Dashboard/Cofund';
import LevelRewardSetting from './Dashboard/LevelIncome';
import Support from './Dashboard/Support';
import Setting from './Dashboard/Setting';
import Notification from './Dashboard/Notification';
import Admin from './Dashboard/Admin';
import Matching from './Dashboard/Matching';
import Treasury from './Dashboard/Treasury';
import Rewards from './Dashboard/Rewards';

// Custom / Auth Views
import Signin from './Custom Page/Signin';
import Signup from './Custom Page/Signup';
import Forgot from './Custom Page/Forgot';
import Reset from './Custom Page/Reset';
import Lockscreen from './Custom Page/Lockscreen';
import UnderMaintenance from './Custom Page/UnderMaintenance';
import Error404 from './Custom Page/Error404';
import Error500 from './Custom Page/Error500';
import Error501 from './Custom Page/Error501';

function AppRoutes() {
  return (
    <Routes>
      {/* Main Dashboard */}
      <Route path="/" element={<Index />} />
      <Route path="/dashboard" element={<Index />} />

      {/* User / Client Management */}
      <Route path="/clients" element={<Client />} />
      <Route path="/Clients" element={<Client />} />
      <Route path="/clientsDetails" element={<ClientDetails />} />
      <Route path="/clients-details" element={<ClientDetails />} />
      <Route path="/userDetails" element={<ClientDetails />} />
      <Route path="/user-details" element={<ClientDetails />} />

      {/* Trades */}
      <Route path="/trades" element={<Trades />} />
      <Route path="/Trades" element={<Trades />} />
      <Route path="/trade" element={<Trades />} />
      <Route path="/Trade" element={<Trades />} />

      {/* Deposits */}
      <Route path="/deposits" element={<Deposits />} />
      <Route path="/Deposits" element={<Deposits />} />
      <Route path="/deposit-wallets" element={<DepositWallet />} />
      <Route path="/Deposit-wallets" element={<DepositWallet />} />

      {/* Withdrawals */}
      <Route path="/client-withdraw" element={<ClientWithdraw />} />
      <Route path="/Clinet-withdraw" element={<ClientWithdraw />} />
      <Route path="/withdraw-request" element={<WithdrawRequest />} />
      <Route path="/trc20-withdraw" element={<Withdraw />} />

      {/* Analytics, Business & Ranks */}
      <Route path="/rank" element={<Rank />} />
      <Route path="/rewards" element={<Rewards />} />
      <Route path="/Rewards" element={<Rewards />} />
      <Route path="/offer-rewards" element={<Rewards />} />
      <Route path="/business" element={<Business />} />
      <Route path="/cofund" element={<Cofund />} />
      <Route path="/level-rewards" element={<LevelRewardSetting />} />
      <Route path="/LevelRewardSetting" element={<LevelRewardSetting />} />

      {/* Wallets & Integrations */}
      <Route path="/matching-bonus" element={<Matching />} />
      <Route path="/master-wallet" element={<MasterWallet />} />
      <Route path="/treasury" element={<Treasury />} />
      <Route path="/blockchain/treasury" element={<Treasury />} />

      {/* Support & Tickets */}
      <Route path="/support" element={<Support />} />
      <Route path="/Support" element={<Support />} />

      {/* Notifications */}
      <Route path="/notification" element={<Notification />} />
      <Route path="/Notification" element={<Notification />} />
      <Route path="/notifications" element={<Notification />} />

      {/* Admin Management */}
      <Route path="/admin" element={<Admin />} />
      <Route path="/admins" element={<Admin />} />

      {/* System Settings */}
      <Route path="/setting" element={<Setting />} />
      <Route path="/settings" element={<Setting />} />

      {/* Authentication & Custom Pages */}
      <Route path="/signin" element={<Signin />} />
      <Route path="/login" element={<Signin />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/Signup" element={<Signup />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/Forgot" element={<Forgot />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/Reset" element={<Reset />} />
      <Route path="/lockscreen" element={<Lockscreen />} />
      <Route path="/under-maintenance" element={<UnderMaintenance />} />
      <Route path="/UnderMaintenance" element={<UnderMaintenance />} />

      {/* Error Pages */}
      <Route path="/error-404" element={<Error404 />} />
      <Route path="/Error404" element={<Error404 />} />
      <Route path="/error-500" element={<Error500 />} />
      <Route path="/Error500" element={<Error500 />} />
      <Route path="/error-501" element={<Error501 />} />
      <Route path="/Error501" element={<Error501 />} />

      {/* 404 Fallback for any unknown route */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
